export interface IAlign {
    vertical?: 'top' | 'center' | 'bottom';
    horizontal?: 'left' | 'center' | 'right';
}

export interface IPadding {
    left?: number;
    top?: number;
    right?: number;
    bottom?: number;
}

type Size = number | 'auto';

export interface ILayout {
    width: number;
    height: number;
    contentPosition: {x: number; y: number;};
}

export function calculateLayout(
    contentWidth: number,
    contentHeight: number,
    width: Size = 0,
    height: Size = 0,
    padding: IPadding = {},
    align: IAlign = {}
): ILayout {
    width = width === 'auto' ? contentWidth : width;
    height = height === 'auto' ? contentHeight : height;

    const contentPadding = {left: 0, top: 0, right: 0, bottom: 0, ...padding};
    const contentAlign = {vertical: 'top', horizontal: 'left', ...align};
    const widthWithPadding = contentWidth + contentPadding.left + contentPadding.right;
    const heightWithPadding = contentHeight + contentPadding.top + contentPadding.bottom;
    const layoutWidth = Math.max(width, widthWithPadding);
    const layoutHeight = Math.max(height, heightWithPadding);
    const {vertical = 'top', horizontal = 'left'} = contentAlign;
    const x = horizontal === 'left' ? contentPadding.left : horizontal === 'center' ? layoutWidth / 2 : layoutWidth - contentPadding.right;
    const y = vertical === 'top' ? contentPadding.top : vertical === 'center' ? layoutHeight / 2 : layoutHeight - contentPadding.bottom;

    return {width: layoutWidth, height: layoutHeight, contentPosition: {x, y}};
}